import PriceDisplay from './PriceDisplay'

export default PriceDisplay
